export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '9c06469b-9ce2-4b23-a246-ead97397e209';
export const MODEL_CLOSE_SEC = 2.5;
